module.exports = __webpack_public_path__ + "img/user.dc239a78.svg";